import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getCurrentPointer } from '../../utils/commonUtils';
import FocusedCaseAllocation from '../../interfaces/focusedCaseAllocation';

interface FocusedCaseAllocationState {
    focusedCaseAllocation: FocusedCaseAllocation[],
    caseCurrentIndex: number;
}

const initialState: FocusedCaseAllocationState = {
    focusedCaseAllocation: [],
    caseCurrentIndex: getCurrentPointer()
}

export const FocusedCaseAllocationSlice = createSlice({
    name: 'FocusedCaseAllocation',
    initialState,
    reducers: {
        loadFocusedCaseAllocation: (state, action: PayloadAction<FocusedCaseAllocation[]>) => {
            state.focusedCaseAllocation = action.payload
        },
        loadCaseCurrentIndex: (state, action: PayloadAction<number>) => {
            state.caseCurrentIndex = action.payload;
        },
    }
});

export const { loadFocusedCaseAllocation, loadCaseCurrentIndex } = FocusedCaseAllocationSlice.actions;

export default FocusedCaseAllocationSlice.reducer;